// extracted by mini-css-extract-plugin
export default {"emptyPlaceholderContainer":"AuditionMessagingMenu_emptyPlaceholderContainer__XNLYc"};